export const en = {
    auto: 'Auto',
    'bid-auto-strategy-info':
        "The bid is calculated based on the automatic strategy's criteria. With automatic bid management strategies, the system takes control over ad placement."
};
